import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={100}
    height={100}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={50} cy={50} r={50} fill="url(#paint0_linear_417_13953)" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 50L31.25 43.75L43.75 56.25L68.75 31.25L75 37.5L43.75 68.75L25 50Z"
      fill="white"
      stroke="white"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_417_13953"
        x1={81.5}
        y1={11}
        x2={-34.5}
        y2={125.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#13CB75" />
        <stop offset={1} stopColor="#13C5CB" />
      </linearGradient>
    </defs>
  </svg>
);

export default SVGComponent;
